import React, { useState, useEffect } from "react";
import { Url } from "../../url";
import './../../entrydoor.css';
import './DoorLiteItems.css';

const DoorLiteItems = ({ value, onChange, selectedCollection, selectedSize,
                                      doorSizeValueToFunc, doorHeightValueToFunc, passSelectedDoor, searchByName = null,
                                      label = "Door lites" }) => {
    const [items, setItems] = useState(value||[]);
    const [selectedDoorLite, setSelectedDoorLite] = useState(null);

    useEffect(() => {
        if (!items || items.length === 0) {
            setSelectedDoorLite(null);
            onChange(null);
        }
    }, [items])

    useEffect(() => {
        //if (selectedSize){
        //    alert(JSON.stringify(selectedSize, null, 2));
        //}
        if (doorSizeValueToFunc){;}
        if (doorHeightValueToFunc){;}
        if (searchByName){;}
        let collectionValue = selectedCollection;
        if (!selectedCollection) { // Dynamically fetch selectedCollection if it's not provided
            const collectionElement = document.getElementById('DoorLiteCollection');
            if (collectionElement) {
                collectionValue = collectionElement.value;
            }
        }
        let sizeValue = selectedSize;
        if (!selectedSize) { // Dynamically fetch selectedCollection if it's not provided
            const sizeElement = document.getElementById('DoorLiteSize');
            if (sizeElement) {
                sizeValue = sizeElement.value;
            }
        }
        // Ensure we continue if at least one filter is defined
        if (!collectionValue && !sizeValue && !doorSizeValueToFunc && !doorHeightValueToFunc && !searchByName) return;

        let w = doorSizeValueToFunc + "\"";
        let h = doorHeightValueToFunc + "\"";
        const url = `${Url}/doorlites?collection=${collectionValue}`; 
        fetch(url) 
            .then((response) => response.json())
            .then((data) => {
                let filteredItems = data;

                // Apply the 'panel' filter only if collectionValue is valid
                if (collectionValue && collectionValue !== "") {
                    //filteredItems = filteredItems.filter(item => item.collection === collectionValue);
 
                }
                if (doorSizeValueToFunc && doorSizeValueToFunc !== "") {
                    //filteredItems = filteredItems.filter(item => item.width === doorSizeValueToFunc + "\"");
                }
                if (sizeValue) {
                    //alert(selectedSize.value);
                    filteredItems = filteredItems.filter(item => item.grain === sizeValue);
                }
                if (searchByName) {
                    filteredItems = filteredItems.filter(item => item.value.toLowerCase().includes(searchByName.toLowerCase()));
                }
                
                if (!Array.isArray(filteredItems)) {
                    console.error("Filtered items is not an array!", filteredItems);
                    setItems([]); // Fallback to an empty array
                    return;
                }
                setItems(filteredItems);
            })
            .catch((error) => {
                console.error("Error fetching items:", error);
                alert("An error occurred while fetching items.");
            });
    }, [selectedCollection, selectedSize, 
        doorSizeValueToFunc, doorHeightValueToFunc, passSelectedDoor, searchByName]); // Dependency array ensures updates trigger

    // onSelect function to handle item selection and unselection
    const handleSelect = (item) => {
        // If the clicked item is already selected, unselect it by setting selectedItem to null
        if (selectedDoorLite && selectedDoorLite.id === item.id) {
            setSelectedDoorLite(null);  // Unselect the item
            onChange(null);  // Notify parent with null to indicate no item is selected
        } else {
            item.a = "132";
            setSelectedDoorLite(item);  // Select the item
            onChange(item);  // Notify parent with the selected item
            //alert(JSON.stringify(item, null, 2));
        }
    };

    return (
        <div className="a-container">
            <label htmlFor="DoorLiteItems">{label}</label>
            <div className="door-items-container">
                {Array.isArray(items) && items.length > 0 ? (
                    items.map((item) => (
                        <div
                        key={item.id}
                        className="door-item"
                        onClick={() => handleSelect(item)}
                        style={{
                          cursor: "pointer",
                          textAlign: "center", // Ensure child elements are centered
                          width: '120px',
                          display: "flex", // Use flexbox
                          flexDirection: "column", // Stack content vertically
                          alignItems: "center", // Horizontal alignment
                          justifyContent: "flex-start", // Align images and content to the top
                        }}
                        >
                        <img
                          src={`images/${item.image}`}
                          alt={item.value}
                          aria-label={`Door item ${item.value}`}
                          style={{
                            alignSelf: "center", // Optional: align image if needed
                            verticalAlign: "top", // Align the image to the top
                            height: "100%", // Set height to 100%
                            width: "50%", // Set width to be 50% of the height
                            objectFit: "cover", // Ensures the image scales properly without distortion
                          }}
                        />
                        <p
                          style={{
                            fontWeight:
                              selectedDoorLite && selectedDoorLite.id === item.id
                                ? "bold"
                                : "normal",
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                            overflowWrap: "break-word", // Break long words
                            textAlign: "center",
                            lineHeight: "1.2", // Adjust for better line spacing
                            margin: "5px 0", // Add some space around the text
                          }}
                        >
                          {item.value}
                        </p>
                      </div>
                      
                    ))
                ) : (
                    <p>No items available for the selected collection.</p>
                )}
            </div>
        </div>
    );
    
};

export default DoorLiteItems;
